export default {
  //get all SUPERADMIN_EXAMs
  GET_SUPERADMIN_EXAMS_REQUEST: "GET_SUPERADMIN_EXAMS_REQUEST",
  GET_SUPERADMIN_EXAMS_SUCCESS: "GET_SUPERADMIN_EXAMS_SUCCESS",
  GET_SUPERADMIN_EXAMS_FAIL: "GET_SUPERADMIN_EXAMS_FAIL",

  GET_ALL_SUPERADMIN_EXAM_QUESTIONS_REQUEST:
    "GET_ALL_SUPERADMIN_EXAM_QUESTIONS_REQUEST",
  GET_ALL_SUPERADMIN_EXAM_QUESTIONS_SUCCESS:
    "GET_ALL_SUPERADMIN_EXAM_QUESTIONS_SUCCESS",
  GET_ALL_SUPERADMIN_EXAM_QUESTIONS_FAIL:
    "GET_ALL_SUPERADMIN_EXAM_QUESTIONS_FAIL",

  CREATE_SUPERADMIN_EXAM_QUESTIONS_REQUEST:
    "CREATE_SUPERADMIN_EXAM_QUESTIONS_REQUEST",
  CREATE_SUPERADMIN_EXAM_QUESTIONS_SUCCESS:
    "CREATE_SUPERADMIN_EXAM_QUESTIONS_SUCCESS",
  CREATE_SUPERADMIN_EXAM_QUESTIONS_FAIL:
    "CREATE_SUPERADMIN_EXAM_QUESTIONS_FAIL",

  GET_SUPERADMIN_EXAMS_SUPER_ADMIN_REQUEST:
    "GET_SUPERADMIN_EXAMS_SUPER_ADMIN_REQUEST",
  GET_SUPERADMIN_EXAMS_SUPER_ADMIN_SUCCESS:
    "GET_SUPERADMIN_EXAMS_SUPER_ADMIN_SUCCESS",
  GET_SUPERADMIN_EXAMS_SUPER_ADMIN_FAIL:
    "GET_SUPERADMIN_EXAMS_SUPER_ADMIN_FAIL",

  GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_REQUEST:
    "GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_REQUEST",
  GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_SUCCESS:
    "GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_SUCCESS",
  GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_FAIL:
    "GET_ADMIN_STUDENT_SUPERADMIN_EXAMS_FAIL",

  //edit SUPERADMIN_EXAMs
  EDIT_SUPERADMIN_EXAM_REQUEST: "EDIT_SUPERADMIN_EXAM_REQUEST",
  EDIT_SUPERADMIN_EXAM_SUCCESS: "EDIT_SUPERADMIN_EXAM_SUCCESS",
  EDIT_SUPERADMIN_EXAM_FAIL: "EDIT_SUPERADMIN_EXAM_FAIL",

  //create SUPERADMIN_EXAM
  CREATE_SUPERADMIN_EXAM_REQUEST: "CREATE_SUPERADMIN_EXAM_REQUEST",
  CREATE_SUPERADMIN_EXAM_SUCCESS: "CREATE_SUPERADMIN_EXAM_SUCCESS",
  CREATE_SUPERADMIN_EXAM_FAIL: "CREATE_SUPERADMIN_EXAM_FAIL",

  DELETE_SUPERADMIN_EXAM_REQUEST: "DELETE_SUPERADMIN_EXAM_REQUEST",
  DELETE_SUPERADMIN_EXAM_SUCCESS: "DELETE_SUPERADMIN_EXAM_SUCCESS",
  DELETE_SUPERADMIN_EXAM_FAIL: "DELETE_SUPERADMIN_EXAM_FAIL",

  PUBLISH_SUPERADMIN_EXAM_REQUEST: "PUBLISH_SUPERADMIN_EXAM_REQUEST",
  PUBLISH_SUPERADMIN_EXAM_SUCCESS: "PUBLISH_SUPERADMIN_EXAM_SUCCESS",
  PUBLISH_SUPERADMIN_EXAM_FAIL: "PUBLISH_SUPERADMIN_EXAM_FAIL",

  GET_SUPERADMIN_EXAM_REQUEST: "GET_SUPERADMIN_EXAM_REQUEST",
  GET_SUPERADMIN_EXAM_SUCCESS: "GET_SUPERADMIN_EXAM_SUCCESS",
  GET_SUPERADMIN_EXAM_FAIL: "GET_SUPERADMIN_EXAM_FAIL",

  ENABLE_SUPERADMIN_EXAM_REQUEST: "ENABLE_SUPERADMIN_EXAM_REQUEST",
  ENABLE_SUPERADMIN_EXAM_SUCCESS: "ENABLE_SUPERADMIN_EXAM_SUCCESS",
  ENABLE_SUPERADMIN_EXAM_FAIL: "ENABLE_SUPERADMIN_EXAM_FAIL",

  RESTRICT_SUPERADMIN_EXAM_REQUEST: "RESTRICT_SUPERADMIN_EXAM_REQUEST",
  RESTRICT_SUPERADMIN_EXAM_SUCCESS: "RESTRICT_SUPERADMIN_EXAM_SUCCESS",
  RESTRICT_SUPERADMIN_EXAM_FAIL: "RESTRICT_SUPERADMIN_EXAM_FAIL",
  //loading
  ADD_SUPERADMIN_EXAMS_LOADING: "ADD_SUPERADMIN_EXAMS_LOADING",
  PUBLISH_SUPERADMIN_EXAM_LOADING: "PUBLISH_SUPERADMIN_EXAM_LOADING",
  RESTRICT_SUPERADMIN_EXAM_LOADING: "RESTRICT_SUPERADMIN_EXAM_LOADING",
  ENABLE_SUPERADMIN_EXAM_LOADING: "ENABLE_SUPERADMIN_EXAM_LOADING",
  EDIT_SUPERADMIN_EXAM_QUESTION_REQUEST:
    "EDIT_SUPERADMIN_EXAM_QUESTION_REQUEST",
  EDIT_SUPERADMIN_EXAM_QUESTION_SUCCESS:
    "EDIT_SUPERADMIN_EXAM_QUESTION_SUCCESS",
  EDIT_SUPERADMIN_EXAM_QUESTION_FAIL: "EDIT_SUPERADMIN_EXAM_QUESTION_FAIL",

  ADD_BULK_CORRECTION_REQUEST: "ADD_BULK_CORRECTION_REQUEST",
  ADD_BULK_CORRECTION_SUCCESS: "ADD_BULK_CORRECTION_SUCCESS",
  ADD_BULK_CORRECTION_FAIL: "ADD_BULK_CORRECTION_FAIL",
  SUPERADMIN_GET_COURSE_EXAM_REQUEST: "SUPERADMIN_GET_COURSE_EXAM_REQUEST",
  SUPERADMIN_GET_COURSE_EXAM_SUCCESS: "SUPERADMIN_GET_COURSE_EXAM_SUCCESS",
  SUPERADMIN_GET_COURSE_EXAM_FAIL: "SUPERADMIN_GET_COURSE_EXAM_FAIL",


  GET_MANUAL_EXAMS_REQUEST: "GET_MANUAL_EXAMS_REQUEST",
  GET_MANUAL_EXAMS_SUCCESS: "GET_MANUAL_EXAMS_SUCCESS",
  GET_MANUAL_EXAMS_FAIL: "GET_MANUAL_EXAMS_FAIL",

  GET_MANUAL_EXAMS_MARKS_REQUEST: "GET_MANUAL_EXAMS_MARKS_REQUEST",
  GET_MANUAL_EXAMS_MARKS_SUCCESS: "GET_MANUAL_EXAMS_MARKS_SUCCESS",
  GET_MANUAL_EXAMS_MARKS_FAIL: "GET_MANUAL_EXAMS_MARKS_FAIL",

  SET_MANUAL_EXAM_MARK_REQUEST: "SET_MANUAL_EXAM_MARK_REQUEST",
  SET_MANUAL_EXAM_MARK_SUCCESS: "SET_MANUAL_EXAM_MARK_SUCCESS",
  SET_MANUAL_EXAM_MARK_FAIL: "SET_MANUAL_EXAM_MARK_FAIL",
};
